import { render } from "./EventsTable.vue?vue&type=template&id=181c8bf0&scoped=true"
import script from "./EventsTable.vue?vue&type=script&lang=js"
export * from "./EventsTable.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=181c8bf0&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181c8bf0"]])

export default __exports__